import ReactDOM from "react-dom/client";
import "./tailwind.css";
import App from "./App.tsx";
import { AppLogger } from "@utils/index";

// Catch unhandled promise rejections globally
window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    AppLogger.error("Unhandled promise rejection:", event.reason);
});

// Enable MobX DevTools in development mode
// Following mobx-devtools rule
if (import.meta.env.DEV) {
    // MobX spy for debugging - logs all MobX actions in console
    import('mobx').then(({ spy }) => {
        spy((event) => {
            if (event.type === 'action') {
                console.debug(`[MobX Action] ${event.name}`, event.arguments);
            }
        });
    });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// StrictMode removed: its dev-only double-mount destroys and recreates
// the WebGL context used by React Three Fiber, causing a blank screen.
// Production builds are unaffected (StrictMode has no runtime effect).
root.render(
    <App />
);
